<script>
    import { onMount, createEventDispatcher } from 'svelte';
    import { generateID, addPendingMedia, fetchData, getLocalServer } from '../utils/Data.svelte'
    import { arrowRoundBack } from 'ionicons/icons/index.mjs';
    export let session;
    export let modal;
    export let tooltips;
    let loading = false;
    let error = "";
    let id = generateID();
    let type = "file";
    let name = "";
    let tag = "";
    let description = "";
    let group = "";
    let link = "";
    let selected = "";
    let files;
	const dispatch = createEventDispatcher();
    onMount(async () => {
        if (window.platform == "Android") {
            androidAdapter.checkCameraPermission();
        }
        console.log(modal)
        if (modal.media) {
            console.log(modal.media)
            name = modal.media.name;
            description = modal.media.description;
            group = modal.group;
            if (modal.media.type == "link") {
                type = modal.media.type;
                link = modal.media.uri;
            }
            else if (modal.media.type == "download") {
                type = "download"
            }
        }
    });
    async function sendHandler(data, fileList) {
        var isScene = true;
        var path = "/scene/" + modal.id;
        var version = "0";
        if (modal.feature && modal.layer) {
            if (modal.layer.id && modal.layer.id.startsWith("reportlog")) {
                path = "/report/" + modal.feature.properties.history_id;
                isScene = false;
            }
            else if (modal.layer.source) {
                let parts = modal.layer.source.split("_");
                if (parts.length == 2 && modal.layer.metadata) {
                    /*if (modal.layer.metadata["geosync:version"] && modal.feature.properties[modal.layer.metadata["geosync:version"]]) {
                        version = modal.feature.properties[modal.layer.metadata["geosync:version"]];
                    }*/
                    path = "/layer/" + modal.layer.metadata["geosync:media"] + "/" + modal.feature.properties[modal.layer.metadata["geosync:id"]] + "/" + version;
                    isScene = false;
                }
            }
            else {
                path = "/layer/" + modal.layer + "/" + modal.feature + "/0"
            }
        }

        let [res, err]  = await fetchData("/v1/media" + path, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + session.token
            },
            body: data
        });
        console.log(err);
        loading = false;
        dispatch('message', {
            type: "toast",
            data: {
                message: "Media saved."
            }
        });
        close();
		if (err) {
            if (type === "link") {
                addPendingMedia({
                    id: generateID(),
                    name,
                    description,
                    group,
                    type,
                    path,
                    link
                });
            }
            else if (fileList.length > 0) {
                for (var i = 0; i < fileList.length; i++) {
                    let file = fileList[i].file;
                    let fullname = fileList[i].name;
                    var reader = new FileReader();
                    reader.onload = function(e) {
                        addPendingMedia({
                            id: generateID(),
                            name,
                            description,
                            group,
                            type,
                            path,
                            filename: fullname
                        }, e.target.result);
                    }
                    reader.readAsDataURL(file);
                }
            }
        }
        else {
            dispatch('message', {
                type: "media",
                data: {
                    isScene: isScene
                }
            });
        }
    }
    async function uploadHandler (e) {
        e.currentTarget.blur();
        console.log(session);
        var base = "https://geosync.blob.core.windows.net/" + session.account + "/media";
        var isScene = true;
        var path = "/scene/" + modal.id;
        if (modal.feature && modal.layer) {
            if (modal.layer.id && modal.layer.id.startsWith("reportlog")) {
                path = "/report/" + modal.feature.properties.history_id;
                isScene = false;
            }
            else if (modal.layer.metadata && modal.layer.metadata["geosync:media"] && modal.layer.metadata["geosync:id"] && modal.feature.properties[modal.layer.metadata["geosync:id"]]) {
                path = "/layer/" + modal.layer.metadata["geosync:media"] + "/" + modal.feature.properties[modal.layer.metadata["geosync:id"]];
                isScene = false;
            }
            else {
                path = "/layer/" + modal.layer + "/" + modal.feature
            }
        }
        let [res, err]  = await fetchData(getLocalServer() + "/upload", {
                method: "POST",
                headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    url: base + path + "?" + session.query
                })
        });
    }
    async function saveHandler(e) {
        e.currentTarget.blur();
        loading = true;
        error = "";
        let data = new FormData();
        data.append("name", name);
        data.append("description", description);
        data.append("group", group);
        var fileList = [];
        var now = new Date();
        var prefix = now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate() + "T" + now.getHours() + "-" + now.getMinutes() + "-" + now.getSeconds() + "." + now.getMilliseconds();
        if (modal.media) {
            var filename = "";
            if (modal.media.file) {
                filename = modal.media.file;
            }
            else if (modal.media.type == "link") {
                filename = modal.media.name;
            }
            else {
                var url = new URL(modal.media.uri);
                filename =  decodeURIComponent(url.pathname.substring(url.pathname.lastIndexOf("/") + 1));
                var fname = filename.substring(0, filename.lastIndexOf("."));
                if (fname.toLowerCase() == "image") {
                    var ext = filename.substring(filename.lastIndexOf("."));
                    filename = prefix + ext;
                }
            }
            data.append("filename", filename);
            data.append("type", modal.media.type);
        }
        if (type === "link") {
            data.append("link", link);
            sendHandler(data);
        }
        else if (type == "download") {
            data.append("download", "1")
        }
        else {
            data.append("download", "0")
        }
        if (type != "link") {
            console.log(window.platform);
            console.log(window.apiVersion);
            
            if (window.platform == "Android" && window.apiVersion >= 4 && !window.location.pathname.startsWith("/tables/")) {
                console.log("brain");
                var base = "media";
                var isScene = true;
                var path = "/scene/" + modal.id;
                if (modal.feature && modal.layer) {
                    if (modal.layer.id && modal.layer.id.startsWith("reportlog")) {
                        path = "/report/" + modal.feature.properties.history_id;
                        isScene = false;
                    }
                    else if (modal.layer.metadata && modal.layer.metadata["geosync:media"] && modal.layer.metadata["geosync:id"] && modal.feature.properties[modal.layer.metadata["geosync:id"]]) {
                        path = "/layer/" + modal.layer.metadata["geosync:media"] + "/" + modal.feature.properties[modal.layer.metadata["geosync:id"]];
                        isScene = false;
                    }
                    else {
                        path = "/layer/" + modal.layer + "/" + modal.feature
                    }
                }
                androidAdapter.addMedia(base + path, name, description, group);
                loading = false;
                dispatch('message', {
                    type: "toast",
                    data: {
                        message: "Media saved."
                    }
                });
                close();
            }
            else if (window.platform == "iOS" && window.apiVersion >= 2) {
                console.log("brain");
                var base = "media";
                var isScene = true;
                var path = "/scene/" + modal.id;
                if (modal.feature && modal.layer) {
                    if (modal.layer.id && modal.layer.id.startsWith("reportlog")) {
                        path = "/report/" + modal.feature.properties.history_id;
                        isScene = false;
                    }
                    else if (modal.layer.metadata && modal.layer.metadata["geosync:media"] && modal.layer.metadata["geosync:id"] && modal.feature.properties[modal.layer.metadata["geosync:id"]]) {
                        path = "/layer/" + modal.layer.metadata["geosync:media"] + "/" + modal.feature.properties[modal.layer.metadata["geosync:id"]];
                        isScene = false;
                    }
                    else {
                        path = "/layer/" + modal.layer + "/" + modal.feature
                    }
                }
                try {
                    webkit.messageHandlers.mediaHandler.postMessage({
                        type: "add",
                        path: base + path,
                        name: name,
                        description: description,
                        group: group
                    });
                } catch(err) {
                    console.error(err);
                    createToast({
                        message: "Geolocation error."
                    });
                }
                loading = false;
                dispatch('message', {
                    type: "toast",
                    data: {
                        message: "Media saved."
                    }
                });
                close();
            }
            else {
                console.log("not brain");
                var pendingFiles = 0;
                if (files && files.length) {
                    for (var i = 0; i < files.length; i++) {
                        let file = files[i];
                        var fullname = file.name;
                        var fname = file.name.substring(0, file.name.lastIndexOf("."));
                        if (fname.toLowerCase() == "image") {
                            fname = prefix + "_" + i;
                            var ext = file.name.substring(file.name.lastIndexOf("."));
                            fullname = fname + ext;
                        }
                        if (file.type == "image/jpeg") {
                            pendingFiles++;
                            var reader = new FileReader();
                            reader.onload = function(e) {
                                var image = new Image();
                                image.src = e.target.result;
                                image.onload = function () {
                                    var ratio = this.width / this.height;
                                    if (ratio > 1.7) {
                                    fullname = fname + ".360.jpg" 
                                    }
                                    fileList.push({
                                        file: file,
                                        name: fullname
                                    })
                                    data.append("files", file, fullname);
                                    pendingFiles--;
                                    if (pendingFiles == 0) {
                                        sendHandler(data, fileList);
                                    }
                                };
                            }
                            reader.readAsDataURL(file);   
                        }
                        else {
                            fileList.push({
                                file: file,
                                name: fullname
                            });
                            data.append("files", file, fullname);
                        }
                    }
                }
                if (pendingFiles == 0) {
                    sendHandler(data, fileList);
                }
            }
        }
        else {
            sendHandler(data);
        }
    }

    async function deleteHandler() {
		event.currentTarget.blur();
        loading = true;
        error = "";
        let data = new FormData();
        console.log(modal);
        data.append("name", name);
        if (modal.media) {
            var filename = "";
            if (modal.media.type == "link") {
                filename = modal.media.name;
            }
            else {
                var url = new URL(modal.media.uri);
                filename =  decodeURIComponent(url.pathname.substring(url.pathname.lastIndexOf("/") + 1));
            }
            data.append("filename", filename);
        }
        if (type === "link")
            data.append("link", link);

        var isScene = true;
        var path = "/scene/" + modal.id;
        var version = "0";
        if (modal.feature && modal.layer) {
            if (typeof(modal.layer) != "string" && modal.layer.source) {
                let parts = modal.layer.source.split("_");
                if (parts.length == 2 && modal.layer.metadata) {
                    /*if (modal.layer.metadata["geosync:version"] && modal.feature.properties[modal.layer.metadata["geosync:version"]]) {
                        version = modal.feature.properties[modal.layer.metadata["geosync:version"]];
                    }*/
                    path = "/layer/" + modal.layer.metadata["geosync:media"] + "/" + modal.feature.properties[modal.layer.metadata["geosync:id"]] + "/" + version;
                    isScene = false;
                }
            }
            else {
                path = "/layer/" + modal.layer + "/" + modal.feature + "/" + version
            }
        }
        let [res, err]  = await fetchData("/v1/media/delete" + path, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + session.token
            },
            body: data
        });
        loading = false;
		if (err) {
            dispatch('message', {
                type: "toast",
                data: {
                    message: "Delete failed."
                }
            });
        }
        else {
            dispatch('message', {
                type: "media",
                data: {
                    isScene: isScene
                }
            });
            dispatch('message', {
                type: "toast",
                data: {
                    message: "Media deleted."
                }
            });
        }
        close();
    }

    function iosMediaHandler() {
        selected = "";
        try {
            webkit.messageHandlers.mediaHandler.postMessage({
                type: "get"
            });
        } catch(err) {
            console.error(err);
            createToast({
                message: "Media error."
            });
        }
    }

    function updateSelected(name) {
        selected = name;
    }
    window.updateSelected = updateSelected;
    

	function close() {
		dispatch('message', {
            type: "modal",
            modal: null
		});
    }

    function sendMessage(message) {
		dispatch('message', message);
	}
</script>

<div class="modal active">
    <div class="modal-overlay" on:click={close} aria-label="Close"></div>
    <div class="modal-container">
        <div class="modal-header">
            <div class="tile tile-centered">
                <div class="tile-content">
                    <div class="tile-title">Media Details</div>
                </div>
                <div class="tile-action">
                    {#if modal.media && modal.role > 2}
                        <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Delete" on:click={deleteHandler} aria-label="Delete"><i class="icon icon-delete mt-1"></i></button>
                    {/if}
                    {#if modal.back}
                        <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Back" on:click|stopPropagation={(e) => {
                          e.currentTarget.blur();
                          sendMessage({
                            type: "modal",
                            data: modal.back
                          })
                        }} aria-label="Back"><i class="svg svg-light">{@html arrowRoundBack.md}</i></button>
                    {/if}
                    <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Close" on:click={close} aria-label="Close"><i class="icon icon-cross mt-1"></i></button>
                </div>
            </div>
        </div>
        <div class="modal-body">
            <form class="content" on:submit|preventDefault={saveHandler} autocomplete="off">
                {#if modal.media && type != "link"}
                    <label class="form-label" for="url">URL</label>
                    <input class="form-input" bind:value={modal.media.uri} type="text" id="url" readonly>
                {/if}
                <label class="form-label" for="type">Type</label>
                <select class="form-select" id="type" bind:value={type}>
                    <option>file</option>
                    <option>link</option>
                    <option>download</option>
                </select> 
                <label class="form-label" for="name">Name</label>
                <input class="form-input" bind:value={name} type="text" id="name">
                <label class="form-label" for="description">Description</label>
                <input class="form-input" bind:value={description} type="text" id="description">
                <label class="form-label" for="group">Group</label>
                <input class="form-input" bind:value={group} type="text" id="group">
                <label class="form-label" for="tag">Tag</label>
                <!--<select class="form-select" value={tag}>
                    <option value="" disabled hidden></option>
                    
                </select>-->
                {#if (type == "file" || type == "download") && !modal.media}
                    {#if window.platform == "iOS" && window.apiVersion >= 2}
                        <br />
                        <div class="tile tile-centered text-left">
                            <div class="tile-icon">
                                <input type="button" on:click={iosMediaHandler} value="Choose Files" />
                            </div>
                            <div class="tile-content">
                                <div class="tile-title">{selected ? selected : "no files selected"}</div>
                            </div>
                        </div>
                    {:else}
                        <input class="mt-2 pt-2" type="file" bind:files multiple>
                    {/if}  
                {:else if type == "link"}
                    <label class="form-label" for="link">Link</label>
                    <input class="form-input" bind:value={link} type="text" id="link">
                {/if}
                
                {#if modal.media}
                    <label class="form-label" for="lat">Latitude</label>
                    <input class="form-input" bind:value={modal.media.lat} type="text" id="lat" readonly>
                    <label class="form-label" for="long">Longitude</label>
                    <input class="form-input" bind:value={modal.media.long} type="text" id="long" readonly>
                    <label class="form-label" for="lat">Created</label>
                    <input class="form-input" bind:value={modal.media.created} type="text" id="created" readonly>
                    <label class="form-label" for="lat">Original Name</label>
                    <input class="form-input" bind:value={modal.media.original} type="text" id="original" readonly>
                {/if}
                <input type="submit" style="position: absolute; left: -9999px"/>
            </form>
        </div>
        <div class="modal-footer">
            <div class="tile tile-centered text-left">
                <div class="tile-content">
                    <div class="tile-title error">{error}</div>
                </div>
                {#if modal.role > 1}
                <div class="tile-action">
                    {#if window.platform == "Windows"}
                        <button class="btn btn-primary" on:click={uploadHandler}>Uploader</button>
                    {/if}
                    {#if loading}
                        <button class="btn btn-primary loading">Save</button>
                    {:else}
                        <button class="btn btn-primary" on:click={saveHandler}>Save</button>
                    {/if}
                </div>
                {/if}
            </div>
        </div>
    </div>
</div>

<style>
    .error {
        color: red;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .modal-container {
        padding: 0;
    }
    .modal-container .modal-header {
        background-color: #00ab5f;
        color: #fff;
        padding: 0.2rem 0.4rem;
    }
    .modal-container .modal-header .btn.btn-link {
        color: white;
    }
    .modal-container .modal-body {
        padding: 0rem 0.8rem 0.8rem 0.8rem;
    }
    .modal-container .modal-footer {
        padding: 0.4rem 0.8rem;
        background-color: #efefef;
    }
</style>